<template>
  <ul class="dropdown-menu" aria-labelledby="dLabel" id="userOption">
    <!-- <li v-if="user.role === 'admin'">
      <a :href="backendLink" target="_blank">{{ $t('backend') }}</a>
    </li> -->
    <li>
      <a href="javascript:void(0)" @click="signOut">{{ $t('signOut') }}</a>
    </li>
  </ul>
</template>

<script>
  import locales from '../lang'

  export default {
    name: 'account-user-center-header',
    locales,
    computed: {
      user() {
        return this.$store.state.user
      },
      backendLink() {
        return this.$http.options.root.replace(/www/, 'api') + '/transitToAdmin/' + window.localStorage.getItem('token')
      }
    },
    methods: {
      signOut() {
        this.$store.dispatch('clearUserInfo')
        this.$router.replace('/')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  ul.dropdown-menu {
    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-shadow: 0 .06rem .24rem 0 rgba(0,0,0,0.06);
    border-radius: .08rem;
    padding: 0 .1rem;
    top: .65rem;
    li  a {
      text-align: center;
      font-size: 14px;
      color: #333333;
      letter-spacing: .33px;
      line-height: .6rem;
      height: .6rem;
      background: transparent;
      &:hover {
        font-size: .16rem;
        letter-spacing: .38px;
        font-weight: bold;
      }
    }
    li:not(:last-child) {
      border-bottom: 1px solid #EFEFEF;
    }
  }
</style>



// WEBPACK FOOTER //
// AccountInfoList.vue?5b7b8567